import React, { useState, useCallback } from 'react';
import { Button, Modal } from '@scale/scaleui';
import { addSessionsToCollection } from '../api';
import { useCreateWebinarSession } from '../hooks/useCreateWebinarSessionStore';
import { Scheduler } from './Scheduler';
import { RecurringType } from '@scale/shared/webinarSessions/types';
interface AddSessionsModalProps {
  toggleModal: () => void;
  collectionId: string;
}

export const AddSessionsModal: React.FC<AddSessionsModalProps> = ({
  toggleModal,
  collectionId,
}) => {
  const [sessionType, setSessionType] = useState<RecurringType>(RecurringType.SINGLE);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { reloadSessions } = useCreateWebinarSession();
  const [eventStart, setEventStart] = useState<Date | null>(null);
  const [duration, setDuration] = useState<number | null>(null);
  const [occurrences, setOccurrences] = useState<Date[] | null>(null);
  const handleCreateSessions = useCallback(() => {
    (async () => {
      setIsLoading(true);
      if (eventStart && duration)
        await addSessionsToCollection({
          collectionId,
          eventStart: eventStart.toJSON(),
          duration,
          occurrences: occurrences?.map(o => o.toJSON()) ?? [],
        });
      setIsLoading(false);
      reloadSessions();
      toggleModal();
    })();
  }, [eventStart, collectionId, duration, occurrences, reloadSessions, toggleModal]);

  return (
    <Modal
      title="Add Session(s)"
      open={true}
      onClose={toggleModal}
      actions={
        <div className="flex items-center gap-2 justify-end">
          <Button disabled={isLoading} onClick={handleCreateSessions}>
            {isLoading ? 'Creating...' : 'Create Session(s)'}
          </Button>
        </div>
      }
    >
      <div className="scaleui scale-tailwind min-h-[360px]">
        <Scheduler
          recurring={sessionType}
          setRecurring={setSessionType}
          eventStart={eventStart}
          setEventStart={setEventStart}
          duration={duration}
          setDuration={setDuration}
          occurrences={occurrences}
          setOccurrences={setOccurrences}
        />
      </div>
    </Modal>
  );
};
